import zh from './zh'
import en from './en'
import enUS from 'vant/es/locale/lang/en-US'
import zhCN from 'vant/es/locale/lang/zh-CN'

export default {
    en:{
        ...en,
        ...enUS
    },
    zh:{
        ...zh,
        ...zhCN
    }
}
